var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57145 5.34549L4.67491 5.24204C5.66425 4.25265 7.26835 4.25265 8.2577 5.24204C9.2471 6.23139 9.2471 7.83549 8.2577 8.82484L6.8246 10.2579C5.83525 11.2473 4.23115 11.2473 3.24178 10.2579C2.25241 9.26859 2.25241 7.66449 3.24178 6.67514L3.47395 6.44299",
    stroke: "#5A6572",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5258 5.55697L8.75795 5.32482C9.74735 4.33544 9.74735 2.73136 8.75795 1.74199C7.7686 0.752628 6.1645 0.752628 5.17515 1.74199L3.74202 3.17512C2.75266 4.16449 2.75266 5.76857 3.74202 6.75792C4.73139 7.74732 6.3355 7.74732 7.32485 6.75792L7.4283 6.65447",
    stroke: "#5A6572",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.6d8aceeece4e7542653dc0ddd9e9a81d.svg";
export { ForwardRef as ReactComponent };